






































import { Component, Prop, Vue } from 'vue-property-decorator';

import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import ProgramStatusTag from '@/componentsV2/atoms/ProgramStatusTag/ProgramStatusTag.vue';
import ArrowRightInfoIcon from '@/components/icons/ArrowRightInfo.vue';
import GhostButton from '@/components/molecules/GhostButton/GhostButton.vue';

import { isOnlineProvider } from '@/utils/provider';
import { upperCaseFirstLetter } from '@/utils/string';
import { TProgramStatus } from '@/models/program-status';

@Component({
  components: {
    Typography,
    ProgramStatusTag,
    GhostButton,
    ArrowRightInfoIcon
  }
})
export default class ProgramStatusItem extends Vue {
  @Prop() item!: any;

  programStatus: TProgramStatus[] = [];

  get businessInfo() {
    return this.$store.getters['business/getBusinessState'];
  }

  get tPrefix() {
    return 'programStatus';
  }

  addRowsToList(rows: any) {
    const response = [];

    for (let i = 0; i < rows.length; i++) {
      const element = rows[i];

      if (element.locations.length) {
        element.locations.map((location: any) => {
          response.push({
            ...element,
            ...location,
            label: location.locationName,
            subTitle: location.locationAddress
          });
        });
      } else {
        if (isOnlineProvider(element.provider)) {
          response.push({
            ...element,
            label: this.$t(`${this.tPrefix}.labelCard.online`),
            subTitle: this.businessInfo.website
          });
        } else {
          response.push({
            ...element,
            label: this.$t(`${this.tPrefix}.labelCard.physical`),
            subTitle: this.$t(`${this.tPrefix}.subTitleInStore`, {
              provider: upperCaseFirstLetter(element.provider)
            })
          });
        }
      }
    }

    return response;
  }

  goToProgramStatus() {
    this.$router.push('/program-status');
  }

  created() {
    this.programStatus = this.addRowsToList(this.item.providers);
  }
}
